import { IpCan } from './IpCan';

export default class IpCanLP extends IpCan {}
